import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const styles = theme => ({
  button: {
    display: "block",
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  }
});

class OpenSelect extends React.Component {
  state = {
    age: "",
    open: false
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    this.props.selectedItem(event.target.value);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };
  componentDidMount() {
    let { data, customer } = this.props;
    if (data !== undefined && data.length > 0)
      if (customer !== "All") {
        this.setState({
          selected: data[0].id
        });
      } else {
        this.setState({
          selected: "All"
        });
      }
  }

  render() {
    const { classes, data } = this.props;
    if (data.length <= 0) return null;

    return (
      <form autoComplete="off">
        <FormControl className={classes.formControl} style={{ width: "230px" }}>
          <InputLabel htmlFor="demo-controlled-open-select">
            Select Customer
          </InputLabel>
          <Select
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={
              this.state.selected === undefined
                ? data[0].id
                : this.state.selected
            }
            onChange={this.handleChange}
            inputProps={{
              name: "selected",
              id: "demo-controlled-open-select"
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            {data.length !== 0
              ? data.map(obj => (
                  <MenuItem value={obj.id}>{`${obj.companyName}`}</MenuItem>
                ))
              : null}
          </Select>
        </FormControl>
      </form>
    );
  }
}

OpenSelect.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OpenSelect);



// WEBPACK FOOTER //
// ./src/components/select/select.js